// Centralised API base URL resolver.
//
// CRA bakes `process.env.REACT_APP_BACKEND_URL` into the JS bundle at build
// time. If the production bundle was built with a preview URL (e.g.
// `https://*.preview.emergentagent.com`) embedded, every API call from
// production lands on the wrong host and Cloudflare emits 520.
//
// This resolver protects against that:
//   * In a browser:
//       - if the embedded URL host contains "preview.emergentagent.com" and we
//         are NOT currently on that same preview host, fall back to
//         `window.location.origin`.
//       - if the embedded URL is empty, use `window.location.origin`.
//   * Outside a browser (SSR/build), keep whatever was baked in.
//
// Production deploys should still set REACT_APP_BACKEND_URL=https://storyfyc.com
// in Emergent Secrets. The runtime guard below is a belt-and-braces fallback.

const envUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();

function resolveBackendUrl() {
  if (typeof window === 'undefined') return envUrl;

  const origin = window.location.origin;
  const isPreviewBuild =
    envUrl && /preview\.emergentagent\.com/i.test(envUrl);
  const onPreviewHost = /preview\.emergentagent\.com/i.test(origin);

  if (!envUrl) return origin;
  if (isPreviewBuild && !onPreviewHost) return origin;
  return envUrl;
}

export const BACKEND_URL = resolveBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;
